export default __webpack_public_path__ + "static/media/chevron-up-solid.a6a37e47.svg";